const API_CONSTANTS = {
    API_BASE_URL: process.env.REACT_APP_API_URL,
    ENDPOINTS: {
        ACCOUNT_ABOUT: "account/about",
        ACCOUNT_PROFILE: "account/profile",
        ACCOUNT_PERMISSIONS: "/account/permissions",
        ACCOUNT_CHANGE_PASSWORD: "/Account/ChangePassword",
        ACCOUNT_PASSWORD_HINTS: "/Account/PasswordHints",
        ACCOUNT_PASSWORD_SET: "/Account/SetPassword",
        CONTACT_CENTRE_AGENT_CURRENT: "ContactCentre/Agent/Current",
        CONTACT_CENTRE_CALL_MANAGER_AGENTS_MONITOR: "ContactCentre/CallManager/AgentsMonitor",
        CONTACT_CENTRE_REASON_CODE: "ContactCentre/ReasonCode",
        CONTACT_CENTRE_STATUS_CODE: "ContactCentre/StatusCode",
        LOCATION: "Location",
        REGISTRATION: "Registration",
        REGISTRATION_NUMBER: "Registration/number",
        CONTACT_CENTRE_CALL_MANAGER_TEAM: "/ContactCentre/CallManager/Team/",
        CONTACT_CENTRE_CALL_MANAGER_REASON: "ContactCentre/CallManager/Reason/",
        CONTACT_CENTRE_CALL_MANAGER_STATUS: "ContactCentre/CallManager/Status/",
        CONTACT_CENTRE_CALL_MANAGER_REQUEST_ASSISTANCE: "ContactCentre/CallManager/RequestAssistance",
        CONTACT_CENTER_CALL_MANAGER_CLEAR_ASSISTANCE_REQUEST_FIRST: "ContactCentre/Agent/",
        CONTACT_CENTER_CALL_MANAGER_CLEAR_ASSISTANCE_REQUEST_SECOND: "/Clear",
        SET_LOCATION_CODE: "/Location/Set/",
        OUTBOUND_DIAL: "/OutboundDialDestination",
        CUSTOM_VALUE: "/CustomValue/",
        RESEND_VERIFICATION_EMAIL: "/Account/Profile/Email/Verify",
    }
}

export default API_CONSTANTS;